import { createPinia } from 'pinia';
import { useAuthStore } from './modules/auth';

// 创建pinia实例
const pinia = createPinia();

// 导出store实例和useStore方法
export { pinia, useAuthStore };

export default pinia;